/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../../store/AuthContext';
import { AddittionalPojo } from '../../../../types/PersonalData';
import { TarjetaService } from '../../../../services';
import useAPIError from '../../../../hooks/useAPIError';
import { IconX } from '../../../../Icons';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  additionalData: AddittionalPojo[] | undefined;
  setShowModalConfirmation: (showModal: boolean) => void;
}

const ConfirmCardType: FC<Props> = (props) => {
  const {
    visible,
    setVisible,
    additionalData,
    setShowModalConfirmation,
  } = props;
  const dataUser = useAuthStore();
  const [load, setLoad] = useState<boolean>(false);
  const { t } = useTranslation();
  const { addError, addErrorBack } = useAPIError();
  const [selectedAdditional, setSelectedAdditional] = useState<AddittionalPojo>(
    { eanTarjetaCliente: '', nombre: '', apellidos: '' },
  );

  const hideModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAdditional({ eanTarjetaCliente: '', nombre: '', apellidos: '' });
    setVisible(false);
  };
  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      setVisible(false);
    }
  };

  useEffect(() => {
    // if (dataUser.user.token !== '')
    setLoad(true);
  }, [dataUser.user.token]);

  useEffect(() => {
    const element = document.getElementById(
      'modal-confirm-card',
    ) as HTMLElement;

    if (visible && element) {
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else if (element) {
      element.removeEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const doRequestNewCard = () => {
    const isApp = dataUser.user.isApp === 'true';
    const data = {
      razonSolicitud: 2,
      isApp,
      adicionalEAN: selectedAdditional.eanTarjetaCliente,
    };
    TarjetaService.requestNewCardForAdditional(data)
      .then((response) => {
        if (response.data.error) {
          setLoad(false);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          setShowModalConfirmation(true);
          setSelectedAdditional({
            eanTarjetaCliente: '',
            nombre: '',
            apellidos: '',
          });
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const handleSubmit = () => {
    setVisible(false);
    doRequestNewCard();
  };

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <div
                className={`modal modal--large ${visible ? 'is-active' : ''}`}
                id="modal-confirm-card"
              >
                <div className="modal__background" />
                <div className="modal__card">
                  <header className="modal__card-head u-flex">
                    <div className="modal__card-title">
                      ¿Para que tarjeta adicional necesitas una nueva?
                    </div>
                    <a
                      href="#"
                      onClick={hideModal}
                      className="modal__card-close modal-cerrar"
                    >
                      <div className="icon icon-medium icon--close">
                        <IconX classCss="" />
                      </div>
                    </a>
                  </header>
                  <section className="modal__card-body">
                    <form method="post">
                      <fieldset>
                        <ul className="u-margin-bottom-medium">
                          {additionalData &&
                            additionalData.map((additional, index) => (
                              <li className="u-margin-bottom">
                                <div className="radio radio-inline">
                                  <input
                                    type="radio"
                                    id={`additional-${additional.eanTarjetaCliente}`}
                                    value={additional.eanTarjetaCliente}
                                    name="necesitastarjeta"
                                    className="form-control"
                                    checked={
                                      selectedAdditional.eanTarjetaCliente ===
                                      additional.eanTarjetaCliente
                                    }
                                    onChange={() =>
                                      setSelectedAdditional(additional)
                                    }
                                  />
                                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
                                  <label
                                    htmlFor={`additional-${additional.eanTarjetaCliente}`}
                                    className="control-label"
                                    onClick={() =>
                                      setSelectedAdditional(additional)
                                    }
                                  >
                                    Para {additional.nombre}{' '}
                                    {additional.apellidos}.
                                  </label>
                                </div>
                              </li>
                            ))}
                        </ul>
                        <div className="botonera">
                          <button
                            type="button"
                            className={`btn btn-primary solicitar-form ${
                              selectedAdditional.eanTarjetaCliente === ''
                                ? 'btn__disable'
                                : ''
                            }`}
                            disabled={
                              selectedAdditional.eanTarjetaCliente === ''
                            }
                            onClick={() => handleSubmit()}
                          >
                            Solicitar
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </section>
                </div>
              </div>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default ConfirmCardType;
